if (!customElements.get('deployer-variant-builder')) {
  customElements.define(
    'deployer-variant-builder',
    class DeployerVariantBuilder extends HTMLElement {
      constructor() {
        super();
        this.mainForm = this.closest('section').querySelector('product-form form[action*="/cart/add"]');
        this.mainAtc = this.mainForm.querySelector('button[type="submit"]');
        this.subscriptionWidget = this.closest('section').querySelector('subscription-widget');
        this.productPrice = parseInt(this.querySelector("[data-product-price]").dataset.productPrice);

        // Listen for changes in the quantity input
        this.querySelectorAll('.deployer-variant-builder_variant').forEach((variant) => {
          if (variant.querySelector('.deployer-variant-builder_quantity') != null) {
            variant.querySelector('.deployer-variant-builder_quantity-input').addEventListener('change', this.onInputQuantityChange.bind(this, variant));
            variant.querySelectorAll('.deployer-variant-builder_quantity-button').forEach((button) => button.addEventListener('click', this.onButtonQuantityClick.bind(this, variant)));
          }
          variant.addEventListener("click", async (event) => {
            this.onChooseVariant(event);
          });
        });

        // Compatibilité avec le widget d'abonnement 👇🏻
        if (this.subscriptionWidget) {
          this.subscriptionWidget.addEventListener('SubscriptionWidgetChanged', () => {
            this.updateSubscriptionWidgetPrices();
            this.addSelectionToForm();
            this.updateResume();
          });
        }
        // Compatibilité avec le widget d'abonnement 👆🏻

        this.mainAtc.addEventListener('click', this.resetSelection.bind(this));

        this.updateEverything();
      }

      validateQtyAvailability(variant) {
        const input = variant.querySelector('.deployer-variant-builder_quantity-input');
        const value = parseInt(input.value);
        if (value > input.max) {
          input.value = input.max;
        }
      }

      onInputQuantityChange(variant) {
        this.validateQtyAvailability(variant);
        this.updateEverything();
      }

      onButtonQuantityClick(variant) {
        const input = variant.querySelector('.deployer-variant-builder_quantity-input');
        if (event.target.name === 'plus') {
          input.stepUp();
        } else {
          input.stepDown();
        }
        this.updateEverything();
      }

      async onChooseVariant(event) {
        event.preventDefault();
        const productInfo = document.querySelector('product-info');
        if (!productInfo) return;

        const target = event.target.closest('.deployer-variant-builder_variant');
        const productUrl = productInfo.getProductInfoUrl(target.dataset.productUrl, target.dataset.variantId, false);
        const response = await fetch(productUrl);
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const mediaGallery = html.querySelector('media-gallery ul');
        const variantFeaturedMediaId = mediaGallery?.querySelector('li[data-media-id]')?.dataset.mediaId;
        const scrollY = window.scrollY;

        const isImageClick = event.target.tagName.toLowerCase() === 'img';

        if (!isImageClick) {
          document.body.style.position = 'fixed';
          document.body.style.top = `-${scrollY}px`;
          document.body.style.width = '100%';
          document.body.style.overflowY = 'scroll';
        }

        // Ne mettre à jour les médias que si variantFeaturedMediaId existe
        if (variantFeaturedMediaId) {
          productInfo.updateMedia(html, variantFeaturedMediaId, true);
        }

        setTimeout(() => {
          if (!isImageClick) {
            const savedScrollY = Math.abs(parseInt(document.body.style.top, 10));
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflowY = '';
            window.scrollTo({ top: savedScrollY, behavior: 'instant' });
          }
        }, 50);

        const thumbnailsContainer = document.querySelector('media-gallery [id^="GalleryThumbnails"]');
        if (thumbnailsContainer) {
          const newThumbnails = html.querySelector('media-gallery [id^="GalleryThumbnails"]');
          if (newThumbnails) {
            thumbnailsContainer.innerHTML = newThumbnails.innerHTML;

            thumbnailsContainer.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
              mediaToSwitch
                .querySelector('button')
                .addEventListener('click', () => {
                  const mediaGallery = document.querySelector('media-gallery');
                  if (mediaGallery) {
                    mediaGallery.setActiveMedia(mediaToSwitch.dataset.target);
                  }
                });
            });
          }
        }
      }

      updateEverything() {
        this.updateMainPrices();
        this.updateActiveVariant();
        if (this.subscriptionWidget) this.updateSubscriptionWidgetPrices();
        this.addSelectionToForm();
        this.updateJauge();
        this.updateResume();
        this.updateAddToCartState();
      }

      resetMainFormInputs() {
        if (this.mainForm.querySelector('[name="id"]')) this.mainForm.querySelector('[name="id"]').remove();
        if (this.mainForm.querySelector('[name="quantity"]')) this.mainForm.querySelector('[name="quantity"]').remove();
        document.querySelectorAll('.from-variant-builder').forEach((input) => input.remove());
      }

      resetSelection(event) {
        event.preventDefault();
        setTimeout(() => {
          this.querySelectorAll('.deployer-variant-builder_quantity-input').forEach((input) => {
            input.value = 0;
          });
          this.updateEverything();
        }, 500);
      }

      addSelectionToForm() {
        this.resetMainFormInputs();
        var index = 0;
        this.querySelectorAll('.deployer-variant-builder_quantity-input').forEach((input) => {
          if (input != null && input.value > 0) {
            this.mainForm.insertAdjacentHTML('beforeend', `<input type="hidden" class="from-variant-builder" name="items[${index}][id]" value="${input.dataset.variantId}"><input type="hidden" class="from-variant-builder" name="items[${index}][quantity]" value="${input.value}">`);
            // Compatibilité avec le widget d'abonnement 👇🏻
            if (this.mainForm.querySelector('[name="selling_plan"]')) {
              if (this.mainForm.querySelector('[name="selling_plan"]').value != '' && this.mainForm.querySelector('[name="selling_plan"]').value != null) {
                this.mainForm.insertAdjacentHTML('beforeend', `<input type="hidden" class="from-variant-builder" name="items[${index}][selling_plan]" value="${this.mainForm.querySelector('[name="selling_plan"]').value}">`);
              }
            }
            // Compatibilité avec le widget d'abonnement 👆🏻
            index++;
          }
        });
      }

      updateJauge() {
        var reste = this.getNumberOfSelectedVariants();
        this.querySelectorAll('.deployer-variant-builder_progress-group').forEach((progressGroup) => {
          const progress = progressGroup.querySelector('progress');
          progressGroup.querySelector('.deployer-variant-builder_progress-title').classList.remove('deployer-variant-builder_progress-title_active');
          if (reste > 0) {
            if (reste >= progress.dataset.max) {
              progress.value = 100;
              reste -= progress.dataset.max;
              progressGroup.querySelector('.deployer-variant-builder_progress-title').classList.add('deployer-variant-builder_progress-title_active');
            } else {
              progress.value = 100 * (reste / progress.dataset.max);
              reste = 0;
            }
          } else {
            progress.value = 0;
          }
        });
      }

      checkSubscriptionWidgetState() {
        return this.subscriptionWidget != null && this.subscriptionWidget.querySelector('input[name="purchase_type"]:checked').value == 'subscription';
      }

      updateMainPrices() {
        const total = this.getSelectionTotalPrice() > 0 ? formatPrice(this.getSelectionTotalPrice()) : formatPrice(this.productPrice);
        const discountedTotal = this.getSelectionTotalDiscountedPrice() > 0 ? formatPrice(this.getSelectionTotalDiscountedPrice()) : formatPrice(this.productPrice);
        const discountedTotalAndSubbed = formatPrice(this.getSelectionTotalSubbedPrice());

        // Specifically developped for Dawn Themes:
        this.closest('.product__info-wrapper')
          .querySelectorAll('.price__container')
          .forEach((priceContainer) => {
            if (this.checkSubscriptionWidgetState()) {
              if (total != discountedTotalAndSubbed) {
                priceContainer.closest('.price').classList.add('price--on-sale');
                priceContainer.querySelector('.price__sale .price-item--regular').innerHTML = total;
                priceContainer.querySelector('.price__sale .price-item--sale').innerHTML = discountedTotalAndSubbed;
              } else {
                priceContainer.closest('.price').classList.remove('price--on-sale');
                priceContainer.querySelector('.price__regular .price-item--regular').innerHTML = total;
              }
            } else {
              if (total != discountedTotal) {
                priceContainer.closest('.price').classList.add('price--on-sale');
                priceContainer.querySelector('.price__sale .price-item--regular').innerHTML = total;
                priceContainer.querySelector('.price__sale .price-item--sale').innerHTML = discountedTotal;
              } else {
                priceContainer.closest('.price').classList.remove('price--on-sale');
                priceContainer.querySelector('.price__regular .price-item--regular').innerHTML = total;
              }
            }
          });
      }

      updateActiveVariant() {
        const quantityElements = this.querySelectorAll('.deployer-variant-builder_quantity-input');

        quantityElements.forEach((element) => {
          if (element.value > 0)
            element.closest('.deployer-variant-builder_variant').classList.add('active')
          else
            element.closest('.deployer-variant-builder_variant').classList.remove('active')
        })
      }

      updateSubscriptionWidgetPrices() {
        const total = this.getSelectionTotalPrice() > 0 ? formatPrice(this.getSelectionTotalPrice()) : formatPrice(this.productPrice);
        const discountedTotal = this.getSelectionTotalDiscountedPrice() > 0 ? formatPrice(this.getSelectionTotalDiscountedPrice()) : formatPrice(this.productPrice);
        const subscriptionDiscount = this.subscriptionWidget.querySelector('.custom-option--selected').dataset.ajustmentValue;

        //Update du one-time purchase
        if (total != discountedTotal) {
          this.subscriptionWidget.querySelector('.sw-one-time-purchase--price').innerHTML = '<s>' + total + '</s>' + '<span>' + discountedTotal + '</span>';
        } else {
          this.subscriptionWidget.querySelector('.sw-one-time-purchase--price').innerHTML = total;
        }

        //Update de l'abonnement
        this.subscriptionWidget.querySelector('.sw-subscription-purchase--compare-price').innerHTML = total;
        const reworkedUnitPrice = (this.getSelectionTotalPrice() > 0 ? this.getSelectionTotalPrice() : this.productPrice) / (this.getNumberOfSelectedVariants() > 0 ? this.getNumberOfSelectedVariants() : 1);
        const reworkedPriceDiscounted = reworkedUnitPrice > 0 ? Math.round((reworkedUnitPrice - (reworkedUnitPrice * subscriptionDiscount) / 100)) * (this.getNumberOfSelectedVariants() > 0 ? this.getNumberOfSelectedVariants() : 1) : 0;
        this.subscriptionWidget.querySelector('.sw-subscription-purchase--price').innerHTML = formatPrice(reworkedPriceDiscounted.toFixed(0));
      }

      updateResume() {
        // Nombre d'unités
        if (this.querySelector('.deployer-variant-builder_resume-nombre-unite') != null) {
          const unitLabel = this.querySelector('.deployer-variant-builder_resume-nombre-unite #unitLabel');
          const unitQuantity = this.querySelector('.deployer-variant-builder_resume-nombre-unite #unitQuantity');
          unitQuantity.innerHTML = this.getNumberOfSelectedVariants();
          if (this.getNumberOfSelectedVariants() > 1) {
            unitLabel.innerHTML = unitLabel.dataset.labelPluriel;
          } else {
            unitLabel.innerHTML = unitLabel.dataset.labelSingulier;
          }
        }

        // Nombre de sous-unités
        if (this.querySelector('.deployer-variant-builder_resume-nombre-sous-unite') != null) {
          const sousUnitLabel = this.querySelector('.deployer-variant-builder_resume-nombre-sous-unite #sousUnitLabel');
          const sousUnitQuantity = this.querySelector('.deployer-variant-builder_resume-nombre-sous-unite #sousUnitQuantity');
          const totalSousUnit = this.getNumberOfSelectedVariants() * parseInt(sousUnitLabel.dataset.unitFactor);
          sousUnitQuantity.innerHTML = totalSousUnit;
          if (totalSousUnit > 1) {
            sousUnitLabel.innerHTML = sousUnitLabel.dataset.labelPluriel;
          } else {
            sousUnitLabel.innerHTML = sousUnitLabel.dataset.labelSingulier;
          }
        }

        // Prix par unité
        if (this.querySelector('.deployer-variant-builder_resume-unite-price') != null) {
          const priceByUnit = this.querySelector('.deployer-variant-builder_resume-unite-price #priceByUnit');
          if (this.getNumberOfSelectedVariants() === 0) {
            priceByUnit.innerHTML = '';
          } else {
            if (this.checkSubscriptionWidgetState()) {
              priceByUnit.innerHTML = formatPrice(this.getPriceByUnitAndSubbed()) + ' ' + priceByUnit.dataset.label;
            } else {
              priceByUnit.innerHTML = formatPrice(this.getPriceByUnit()) + ' ' + priceByUnit.dataset.label;
            }
          }
        }
      }

      updateAddToCartState() {
        const mainAtcButton = this.mainForm.querySelector('button[type="submit"]');
        const popupBuyModal = this.closest('popup-buy-modal');
        // On force le texte du bouton à être celui par défaut, sinon ca ne fonctionne pas sur les variantes épuisées
        if (document.querySelector('.deployer-variant-builder_variant:not(.deployer-variant-builder_variant-disabled)') != null) {
          mainAtcButton.querySelector('.product-form__submit__text').innerText = mainAtcButton.dataset.availableText;
        }
        if (this.getNumberOfSelectedVariants() === 0) {
          if (popupBuyModal) {
            popupBuyModal.querySelector('.popup-buy_next-step-button').setAttribute('disabled', 'disabled');
          }
          mainAtcButton.setAttribute('disabled', 'disabled');
          if (document.querySelector('sticky-atc-button button') != null) {
            document.querySelector('sticky-atc-button button').setAttribute('disabled', 'disabled');
          }
        } else {
          if (popupBuyModal) {
            popupBuyModal.querySelector('.popup-buy_next-step-button').removeAttribute('disabled');
          }
          mainAtcButton.removeAttribute('disabled');
          if (document.querySelector('sticky-atc-button button') != null) {
            document.querySelector('sticky-atc-button button').removeAttribute('disabled', 'disabled');
          }
        }

        // Copie et met à jour le résumé dans le sticky également
        if (document.querySelector('.sticky-atc-button_container') != null) {
          if (document.querySelector('.sticky-atc-button_container .deployer-variant-builder_resume-container') == null) {
            const stickyContainer = document.querySelector('.sticky-atc-button_container');
            const resumeCopy = this.querySelector('.deployer-variant-builder_resume-container').cloneNode(true);
            stickyContainer.insertBefore(resumeCopy, stickyContainer.firstChild);
          } else {
            document.querySelector('.sticky-atc-button_container .deployer-variant-builder_resume-container').innerHTML = this.querySelector('.deployer-variant-builder_resume-container').innerHTML;
          }
        }
      }

      getNumberOfSelectedVariants() {
        var totalSelectedVariants = 0;
        this.querySelectorAll('.deployer-variant-builder_quantity-input').forEach((input) => {
          totalSelectedVariants += parseInt(input.value);
        });
        return totalSelectedVariants;
      }

      getSelectionTotalPrice() {
        var total = 0;
        this.querySelectorAll('.deployer-variant-builder_variant').forEach((variant) => {
          if (variant.querySelector('.deployer-variant-builder_quantity-input') != null) {
            const price = parseInt(variant.dataset.variantPrice);
            const quantity = parseInt(variant.querySelector('.deployer-variant-builder_quantity-input').value);
            total += price * quantity;
          }
        });
        return total;
      }

      getSelectionTotalDiscountedPrice() {
        var reachedDiscount = 0;
        paliers_reduction.forEach((palier) => {
          if (this.getNumberOfSelectedVariants() >= palier.quantity) {
            reachedDiscount = palier.discount;
          }
        });

        var discountedTotal = 0;
        this.querySelectorAll('.deployer-variant-builder_variant').forEach((variant) => {
          if (variant.querySelector('.deployer-variant-builder_quantity-input') != null) {
            const price = parseInt(variant.dataset.variantPrice);
            const quantity = parseInt(variant.querySelector('.deployer-variant-builder_quantity-input').value);
            const variant_discounted_price = (price - (price * reachedDiscount) / 100).toFixed(0);
            discountedTotal += variant_discounted_price * quantity;
          }
        });
        return discountedTotal;
      }

      getSelectionTotalSubbedPrice() {

        let discountedTotal = 0;
        this.querySelectorAll('.deployer-variant-builder_variant').forEach((variant) => {
          if (variant.querySelector('.deployer-variant-builder_quantity-input') != null) {
            let price = parseInt(variant.dataset.variantPrice);
            if (this.subscriptionWidget !== null) {
              const selectedPurchaseType = this.subscriptionWidget.querySelector('input[name="purchase_type"]:checked').value;
              if (selectedPurchaseType === 'subscription') {
                const selectedOption = this.subscriptionWidget.querySelector('.custom-option--selected');
                const adjustementType = selectedOption.dataset.ajustmentType;
                const adjustementValue = parseFloat(selectedOption.dataset.ajustmentValue);
                switch (adjustementType) {
                  case 'fixed_amount':
                    price = (price - adjustementValue);
                    break;
                  case 'percentage':
                    price = (price * (1 - adjustementValue / 100));
                    break;
                  case 'price':
                    price = price;
                    break;
                  default:
                    price = price;
                    break;
                }
              }
            }
            const quantity = parseInt(variant.querySelector('.deployer-variant-builder_quantity-input').value);
            const variant_discounted_price = (price).toFixed(0);
            discountedTotal += variant_discounted_price * quantity;
          }
        });
        return discountedTotal;
      }

      getPriceByUnit() {
        return this.getSelectionTotalDiscountedPrice() / this.getNumberOfSelectedVariants();
      }

      getPriceByUnitAndSubbed() {
        return this.getSelectionTotalSubbedPrice() / this.getNumberOfSelectedVariants();
      }
    }
  );
}
